import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MdEmail, MdLock, MdPerson, MdVisibility, MdVisibilityOff } from 'react-icons/md'; // Material Design email icon
import { useNavigate } from 'react-router-dom';

function TeacherSignUp1() {
    useEffect(() => {
        localStorage.clear();
        sessionStorage.clear()
    }, [])



    const [language, setLanguage] = useState(() => {
        const languageNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return languageNow;
    })

    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    // const handleClickOpen = () => {
    //     setOpen(true);
    // };

    // const handleClose = () => {
    //     setOpen(false);
    // };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const [TeacherSignupDetails, setTeacherSignupDetails] = useState(
        {
            name: '',
            email: '',
            password: '',
            confirmPassword: '',
            district: ''
        }
    )

    useEffect(() => {
        localStorage.removeItem('teachersignup1');
    }, [])

    const [errors, setErrors] = useState(
        {
            noEmail: false,
            invalidEmail: false,
            noPassword: false,
            passwordsNotMatch: false,
            noName: false,
            invalidName: false,
            noDistrict: false
        }
    )

    const handleContinue = () => {

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const nameRegex = /^[^\d]*$/;
        let newErrors = {};

        newErrors.noEmail = !TeacherSignupDetails.email;
        newErrors.noPassword = !TeacherSignupDetails.password;
        newErrors.noName = !TeacherSignupDetails.name;
        newErrors.noDistrict = !TeacherSignupDetails.district;

        if (TeacherSignupDetails.password && (TeacherSignupDetails.confirmPassword) !== (TeacherSignupDetails.password)) {
            newErrors.passwordsNotMatch = true;
        } else {
            newErrors.passwordsNotMatch = false;
        }

        // if ((TeacherSignupDetails.email) && !emailRegex.test(TeacherSignupDetails.email)) {
        //     newErrors.invalidEmail = true;
        // } else {
        //     newErrors.invalidEmail = false;
        // }

        if ((TeacherSignupDetails.name) && !nameRegex.test(TeacherSignupDetails.name)) {
            newErrors.invalidName = true;
        } else {
            newErrors.invalidName = false;
        }

        setErrors(newErrors);

        if (Object.values(newErrors).some((error) => error)) {
            return;
        }

        localStorage.setItem('teachersignup1', JSON.stringify(TeacherSignupDetails))
        localStorage.setItem('language', language);
        navigate('/teacherclassdetails');
    }

    const [isVisible, setIsVisible] = useState(false);
    const [isVisibleText, setIsVisibleText] = useState(true);

    const [isVisible2, setIsVisible2] = useState(false);
    const [isVisibleText2, setIsVisibleText2] = useState(true);

    const handleVisiblityClick = () => {
        setIsVisible(!isVisible);
        if (!isVisible && TeacherSignupDetails.password.length > 0) {
            setIsVisibleText(true);
        } else if (isVisible && TeacherSignupDetails.password.length > 0) {
            setIsVisibleText(false);
        }
    }

    const handleVisiblityClick2 = () => {
        setIsVisible2(!isVisible2);
        if (!isVisible2 && TeacherSignupDetails.password.length > 0) {
            setIsVisibleText2(true);
        } else if (isVisible2 && TeacherSignupDetails.password.length > 0) {
            setIsVisibleText2(false);
        }
    }

    const [passwordStatus, setPasswordStatus] = useState({
        weak: false,
        medium: false,
        strong: false
    })

    const errorMessages =
        [
            '',
            t('t60'),
            t('t61'),
            t('t62'),
            t('t63'),
            t('t64'),
        ]

    const [errorMessageNumber, setErrorMessageNumber] = useState(0)

    const regexPatterns = [
        /^.{1,7}$/,  // weak password
        /^(?:[a-z]{8,}|[A-Z]{8,}|[0-9]{8,}|[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,})$/,  // medium password
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#*$%^&+=]).{8,}$/,  // strong password
        /(?=.*[A-Z])/,  // contains at least 1 uppercase letter
        /(?=.*[a-z])/,  // contains at least 1 lowercase letter
        /(?=.*[0-9])/,  // contains at least 1 numeric digit
        /(?=.*[!@#*$%^&+=])/,  // contains at least 1 special character
        /^.{8,}$/,  // password length greater than 8 characters
    ];

    const districtArray = ["Ampara", "Anuradhapura", "Badulla", "Batticaloa", "Colombo", "Galle", "Gampaha", "Hambantota", "Jaffna", "Kalutara", "Kandy",
        "Kegalle", "Kilinochchi", "Kurunegala", "Mannar", "Matale", "Matara", "Monaragala", "Mullaitivu", "Nuwara Eliya", "Polonnaruwa", "Puttalam",
        "Ratnapura", "Trincomalee", "Vavuniya"];

    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} bg-bgImg md:bg-bglarge  bg-no-repeat bg-cover min-h-screen w-screen flex flex-col justify-center pl-[30px] pr-[30px] md:items-center `}>
            <Menu as="div" className="absolute top-0 right-0 m-[10px] text-left items-right">
                <div>
                    <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                        {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />
                    </MenuButton>
                </div>

                <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    <div className="py-1">
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("English");
                                    changeLanguage('en')
                                }}
                            >
                                English
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Sinhala");
                                    changeLanguage('si')
                                }}
                            >
                                සිංහල
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Tamil");
                                    changeLanguage('ta')
                                }}
                            >
                                தமிழ்
                            </button>
                        </MenuItem>
                    </div>
                </MenuItems>
            </Menu>
            <div className='flex flex-col justify-center h-full sm:w-full sm:w-full md:w-[400px] lg:w-[500px] xl:w-[500px]  2xl:w-[500px] mt-[10px]'>
                <img src="/images/logo.svg" className="h-[150px]" alt='logo' />
                <p className="text-center text-[30px] mt-[10px]">{t('t1')}</p>
                <p className='mt-[20px] text-[16px] font-bold text-[#FDC50C]'>{t('t357')}</p>
                <div className="items-center mt-[10px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                    <MdPerson size="24px" color="#8189B0" />
                    <input type="text" name="name" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t27')}
                        onChange={(e) => {
                            setTeacherSignupDetails((prevState) => ({
                                ...prevState, name: e.target.value
                            }))
                        }}
                    />
                </div>
                {errors.noName &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t29')}</p>
                }
                {errors.invalidName &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t28')}</p>
                }

                <div className="items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                    <MdEmail size="24px" color="#8189B0" />
                    <input type="text" name="email" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t441')}
                        onChange={(e) => {
                            setTeacherSignupDetails((prevState) => ({
                                ...prevState, email: e.target.value.toLowerCase()
                            }))
                        }}
                    />
                </div>
                {errors.noEmail &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t15')}</p>
                }
                {errors.invalidEmail &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t16')}</p>
                }

                <div className="items-center mt-[20px] flex h-[50px] md:h-[60px] xl:h-[50px] 2xl:h-[60px]">
                    <Menu as="div" className="w-full relative inline-block text-left py-[20px]">
                        <div>
                            <MenuButton
                                className={`truncate pl-[20px] inline-flex w-full justify-left items-center rounded-md bg-[#F1F6FB] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] text-[15px] ${TeacherSignupDetails.district === "" ? 'text-gray-500' : 'text-gray-900'} shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-100 pr-[30px]`}
                            >
                                {TeacherSignupDetails.district === "" ? t('t55') : TeacherSignupDetails.district}
                                <ChevronDownIcon
                                    aria-hidden="true"
                                    className="absolute right-[10px] size-5 text-gray-700"
                                />
                            </MenuButton>
                        </div>

                        <MenuItems
                            transition
                            className="absolute right-0 z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                            style={{
                                width: '100%',
                                maxHeight: '200px', // Set a reasonable max height
                                overflowY: 'auto' // Enable scrolling for overflow content
                            }}
                        >
                            <div className="py-1">
                                {
                                    districtArray.map((districtSelect, index) => (
                                        <MenuItem key={index}>
                                            <button
                                                className="truncate text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                                onClick={() => {
                                                    setTeacherSignupDetails((prev) => ({ ...prev, district: districtSelect }))
                                                }}
                                            >
                                                {districtSelect}
                                            </button>
                                        </MenuItem>
                                    ))
                                }
                            </div>
                        </MenuItems>
                    </Menu>
                </div>

                {errors.noDistrict &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t56')}</p>
                }

                <div className="items-center mt-[20px] flex rounded-md bg-[#F1F6FB] pl-[10px] pr-[20px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                    <MdLock size="26px" color="#8189B0" />
                    <input
                        type={isVisibleText ? "text" : "password"}
                        name="password"
                        className={`ml-[10px] mr-[10px] w-full bg-[#F1F6FB] text-gray-900 text-[15px] ${isVisibleText ? 'text-[15px] tracking-wide' : 'text-[25px] tracking-widest'} placeholder:text-[#8189B0] focus:outline focus:outline-0`}
                        placeholder={t('t17')}
                        value={TeacherSignupDetails.password}
                        onChange={(e) => {

                            const inputValue = e.target.value.replace(/\s+/g, '').trim();
                            if (inputValue !== "") {
                                setErrors((prev) => ({ ...prev, noPassword: false }));
                                if (regexPatterns[2].test(inputValue)) {
                                    setPasswordStatus((prev) => ({ ...prev, medium: false, weak: false, strong: true }));

                                } else if (regexPatterns[1].test(inputValue)) {
                                    setPasswordStatus((prev) => ({ ...prev, medium: true, weak: false, strong: false }));

                                } else if (regexPatterns[0].test(inputValue)) {
                                    setPasswordStatus((prev) => ({ ...prev, medium: false, weak: true, strong: false }));

                                } else {
                                    setPasswordStatus((prev) => ({ ...prev, medium: true, weak: false, strong: false }));

                                }
                            } else {
                                setErrors((prev) => ({ ...prev, noPassword: false }));
                                setPasswordStatus((prev) => ({ ...prev, medium: false, weak: false, strong: false }));
                            }

                            if (inputValue !== '') {
                                if (!regexPatterns[3].test(inputValue)) {
                                    setErrorMessageNumber(1)
                                } else if (!regexPatterns[4].test(inputValue)) {
                                    setErrorMessageNumber(2)
                                } else if (!regexPatterns[5].test(inputValue)) {
                                    setErrorMessageNumber(3)
                                } else if (!regexPatterns[6].test(inputValue)) {
                                    setErrorMessageNumber(4)
                                } else if (!regexPatterns[7].test(inputValue)) {
                                    setErrorMessageNumber(5)
                                } else {
                                    setErrorMessageNumber(0)
                                }
                            } else {
                                setErrorMessageNumber(0)
                            }

                            setTeacherSignupDetails((prevState) => ({
                                ...prevState, password: inputValue
                            }));
                            if (!isVisible && inputValue.length > 0) {
                                setIsVisibleText(false);
                            } else {
                                setIsVisibleText(true);
                            }
                        }}
                    />
                    {
                        isVisible ? <MdVisibilityOff onClick={handleVisiblityClick} size="24px" color="#8189B0" /> : <MdVisibility onClick={handleVisiblityClick} size="24px" color="#8189B0" />
                    }
                </div>

                {errors.noPassword &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t18')}</p>
                }

                {passwordStatus.weak && <p className='text-black text-[12px] mt-[5px] '>{t('t65')}<span className='text-[#fc0000] font-bold'>{t('t66')}</span></p>
                }
                {passwordStatus.medium && <p className='text-black text-[12px] mt-[5px]'>{t('t65')}<span className='text-[#fc8600] font-bold'>{t('t67')}</span></p>
                }
                {passwordStatus.strong && <p className='text-black text-[12px] mt-[5px]'>{t('t65')}<span className='text-[#099509] font-bold'>{t('t68')}</span></p>
                }

                {errorMessageNumber !== 0 && <p className='text-[#ff0000] text-[12px] mt-[5px] '>{errorMessages[errorMessageNumber]}</p>}

                <div className="items-center mt-[20px] flex rounded-md bg-[#F1F6FB] pl-[10px] pr-[20px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                    <MdLock size="26px" color="#8189B0" />
                    <input type={isVisibleText2 ? "text" : "password"}
                        name="password_confirm"
                        className={`ml-[10px] mr-[10px] w-full bg-[#F1F6FB] text-gray-900 text-[15px] ${isVisibleText2 ? 'text-[15px] tracking-wide' : 'text-[25px] tracking-widest'} placeholder:text-[#8189B0] focus:outline focus:outline-0`}
                        placeholder={t('t30')}
                        value={TeacherSignupDetails.confirmPassword}
                        onChange={(e) => {
                            const inputValue = e.target.value.replace(/\s+/g, '').trim();
                            setTeacherSignupDetails((prevState) => ({
                                ...prevState, confirmPassword: inputValue
                            }));
                            if (!isVisible2 && inputValue.length > 0) {
                                setIsVisibleText2(false);
                            } else {
                                setIsVisibleText2(true);
                            }
                        }}
                    />
                    {
                        isVisible2 ? <MdVisibilityOff onClick={handleVisiblityClick2} size="24px" color="#8189B0" /> : <MdVisibility onClick={handleVisiblityClick2} size="24px" color="#8189B0" />
                    }
                </div>
                {errors.passwordsNotMatch &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t26')}</p>
                }



                <button onClick={handleContinue} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-full hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E] ">{t('t7')}</button>
                <p className="text-black text-[15px] text-center mt-[10px] font-bold mb-[20px]">{t('t8_2')} <span onClick={() => (navigate('/loginas'))} className="text-[#FDC50C] hover:cursor-pointer hover:underline">{t('t25')}</span></p>

            </div>
        </div>
    );
}

export default TeacherSignUp1;